import { useState } from "react";
import { FaLock, FaThumbsUp } from "react-icons/fa";
import teamBanner from '../assets/team-banner.jpg';
import mdTecnico from '../assets/md-tecnico_panoramica.jpg';

const jugadores = [
  { numero: 0, nombre: "Diego Collomb", rol: "Escolta", imagen: "/jugadores/diego-collomb.png" },
  { numero: 6, nombre: "Sebastian Orresta", rol: "Base", imagen: "/jugadores/sebastian-orresta.png" },
  { numero: 10, nombre: "Matías Solanas", rol: "Escolta", imagen: "/jugadores/matias-solanas.png" },
  { numero: 15, nombre: "Brandon Robinson", rol: "Escolta", imagen: "/jugadores/brandon-robinson.png" },
  { numero: 2, nombre: "Johnson, Tyren Milton", rol: "Ala pivot", imagen: "/jugadores/tiren-jonhson.png" },
  { numero: 20, nombre: "Leonardo Lema", rol: "Ala pivot", imagen: "/jugadores/leonardo-lema.png" },
  { numero: 5, nombre: "Freeman, Sammie Ahmaad", rol: "Pivot", imagen: "/jugadores/freeman-sammie.png" },
  { numero: 22, nombre: "Ruesga, Fausto", rol: "Alero", imagen: "/jugadores/ruesga-fausto.png" },
  { numero: 55, nombre: "Jerome Meyinsse", rol: "Pivot", imagen: "/jugadores/jerome-meyinsse.png" },
  { numero: 91, nombre: "Diego Figueredo", rol: "Base", imagen: "/jugadores/diego-figueredo.png" },
    { numero: 1, nombre: "Lucas Victoriano", rol: "DT", imagen: "/jugadores/victoriano.png" },

];

const Equipo = () => {
  const [unlocked, setUnlocked] = useState({});

  const handleUnlock = (index) => {
    setUnlocked((prev) => ({ ...prev, [index]: true }));
  };

  return (
    <div className="px-4 py-6 max-w-7xl mx-auto">
      {/* Título */}
      <h1 className="text-2xl sm:text-3xl font-bold mb-6 text-center">
        NUESTRO PLANTEL
      </h1>

      {/* Banner Team */}
      <div className="mb-6 flex justify-center">
        <img 
          src={teamBanner} 
          alt="Team Banner" 
          className="w-full max-w-7xl object-cover rounded-lg shadow-md"
        />
      </div>

      {/* Banner Equipo Técnico */}
      <div className="mb-6 flex justify-center">
        <img 
          src={mdTecnico} 
          alt="MD Técnico Panorámica" 
          className="w-full max-w-7xl object-cover rounded-lg shadow-md"
        />
      </div>

      {/* Más información */}
      <div className="mb-6 text-center px-4">
        <h2 className="text-xl sm:text-2xl font-semibold mb-2">Desbloquea Nuestro Plantel</h2>
        {/* Más información -> Botón Desbloquear Todos */}
<div className="mb-6 text-center px-4">
  <button
    onClick={() => {
      const allUnlocked = {};
      jugadores.forEach((_, index) => {
        allUnlocked[index] = true;
      });
      setUnlocked(allUnlocked);
    }}
    className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded-lg font-semibold shadow-md flex items-center justify-center gap-2 mx-auto"
  >
    <FaThumbsUp /> DESBLOQUEAR TODOS
  </button>
</div>

      </div>

      {/* Grid de jugadores */}
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 justify-items-center">
        {jugadores.map((jugador, index) => (
          <div 
            key={index} 
            className="relative bg-white rounded-lg shadow-md overflow-hidden w-full max-w-[200px]"
          >
            {!unlocked[index] ? (
              <div className="flex flex-col items-center justify-center bg-gray-800 text-white w-full h-[270px]">
                <FaLock size={40} className="mb-3" />
                <p className="mb-3">BLOQUEADO</p>
                <button
                  onClick={() => handleUnlock(index)}
                  className="bg-red-600 hover:bg-red-700 text-white px-3 py-2 rounded flex items-center gap-2"
                >
                  <FaThumbsUp /> DESBLOQUEAR
                </button>
              </div>
            ) : (
              <div className="relative w-full h-[270px]">
                <img 
                  src={jugador.imagen} 
                  alt={jugador.nombre} 
                  className="object-cover rounded-lg w-full h-full"
                />
                <div className="absolute bottom-12 left-0 bg-red-600 text-white px-2 py-1 font-bold text-sm sm:text-base">
                  {`${jugador.nombre.toUpperCase()} ${jugador.numero}`}
                </div>
                <div className="absolute bottom-0 left-0 bg-blue-600 text-white px-2 py-1 font-semibold text-sm sm:text-base">
                  {jugador.rol.toUpperCase()}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Equipo;
